import React from "react"
import { BrowserRouter as Router } from "react-router-dom"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import resources from "./res/translations"
import Landing from "./Landing"

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: "it-IT",
        fallbackLng: "en-EN",
        defaultNS: "common",
        interpolation: {
            escapeValue: false,
        },
        resources,
    })

function App() {
    return (
        <Router>
            <Landing />
        </Router>
    )
}

export default App
